<template>
  <div class="cb box" v-if="tbdw">
    <p style="padding-top: 60px; text-align: center">
      <span class="red" v-if="csjg">
        {{ csjg }}
      </span>
    </p>
    <table class="list">
      <thead>
        <tr>
          <td v-for="(val, key, index) in tbdwHead" :key="index">{{ key }}</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-for="(val, key, index) in tbdwData" :key="index">{{ val }}</td>
        </tr>
      </tbody>
    </table>
    <div class="btnBox">
      <el-button
        type="primary"
        @click="lookTbdw"
        style="min-width: 130px"
        v-if="!sycbjgbs"
        >查看所有唱标结果</el-button
      >
    </div>
    <!-- 弹窗 -->
    <el-dialog
      title="查看所有唱标结果"
      :visible.sync="dialogTableVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <div style="display: flex; justify-content: space-between;">
        <el-button type="primary" @click="exportCbInfo">导出</el-button>
        <div>
          <el-button @click="refresh" v-if="sfchjy">刷新</el-button>
          <el-input
            style="margin-bottom: 10px; width: 300px; float:  right"
            placeholder="投标单位名称"
            v-model="tbdwmc"
            class="input-with-select"
            clearable
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchTbdw"
            ></el-button>
          </el-input>
        </div>
      </div>
      <!-- 唱标表格 -->
      <cbTable 
        v-loading="loading"
        :tableHead="tableHead" 
        :tableData="tableData" 
        :dcbjHead="dcbjHead" 
        role="B"
        :publishType="isPublish"
      />

      <div class="clear">
        <span class="lf pageNum">共{{ total }}家。</span>
        <myPage
          class="rt"
          :total="total"
          :page-size="pageSize"
          :currentPage="currentPage"
          @changePage="changePage"
        ></myPage>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="dialogTableVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
  <div v-else class="loading">
    <p>正在进行有效性审查，请耐心等待...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
<script>
import myPage from "../components/page";
import cbTable from "./components/cbTable.vue";

export default {
  name: "tbcb",
  props: ["djlcId"],
  components: {
    myPage, cbTable
  },
  data() {
    return {
      tbdw: "",
      zgxj: "",
      kz: "",
      xfbfb: "",
      dialogTableVisible: false,
      tbdwHead: {},
      tbdwData: {},
      tableHead: {},
      tableData: [],
      tbdwmc: "",
      pageSize: 10,
      currentPage: 1,
      total: 0,
      csjg: "",
      lcSteps: JSON.parse(
        sessionStorage.getItem("lcSteps") ? sessionStorage.getItem("lcSteps") : ""
      ),
      aaa: false,
      isPublish: "",
      dcbjHead: [],
      sycbjgbs: true,
      sycbDisabeld: false,
      loading: false,
      timer: null,
      dialogTimer: null,
      sfchjy: false, // 长湖监狱
    };
  },
  created() {
    this.aaa = this.lcSteps.some((item) => {
      return item.ycmc.includes("多次报价");
    });
  },
  watch: {
    dialogTableVisible(newVal) {
      if (newVal && this.sfchjy) {
        // 打开弹窗时启动定时器
        this.dialogTimer = setInterval(() => {
          this.refresh();
        }, 15000);
      } else {
        // 关闭弹窗时清除定时器
        if (this.dialogTimer) {
          clearInterval(this.dialogTimer);
          this.dialogTimer = null;
        }
      }
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.dialogTimer) {
      clearInterval(this.dialogTimer);
      this.dialogTimer = null;
    }
  },
  methods: {
    async getCbData() {
      this.sycbDisabeld = sessionStorage.getItem("sycbDisabeld");
      console.log(this.sycbDisabeld, "222");
      let para = {
        djlcId: this.djlcId,
      };
      const res = await this.$api.zdcbTbr(para);
      if (res.data.meta.success) {
        this.tbdw = res.data.data.tbdw;
        this.kz = res.data.data.kbxm.kz;
        this.xfbfb = res.data.data.kbxm.xfbfb;
        this.zgxj = res.data.data.kbxm.fmzgxj;
        this.csjg = res.data.data.csList;
        this.tbdwHead = res.data.data.bjxsmc;
        this.sycbjgbs = res.data.data.sycbjgbs;
        this.sfchjy = res.data.data.sfchjy;
        var objs = res.data.data.tbdwMap;
        // if (this.aaa) {
        //   this.tbdwData[this.tbdwHead["总报价（元）"]] =
        //     res.data.data.tbdw.tbbj;
        // } else {
        for (let key in this.tbdwHead) {
          if (res.data.data.tbdwMap) {
            this.tbdwData[this.tbdwHead[key]] =
              res.data.data.tbdwMap[this.tbdw.id][this.tbdwHead[key]];
          } else {
            this.tbdwData[this.tbdwHead[key]] =
              res.data.data.tbdw[this.tbdwHead[key]];
          }
        }
        // }
      } else {
        this.$message({
          type: "error",
          message: res.data.meta.message,
        });
      }
    },
    async lookTbdw() {
      this.dialogTableVisible = true;
      this.currentPage = 1;
      this.tbdwmc = "";
      
      this.getData();
    },

    getFileType() {
      return this.$api
        .judgeType()
        .then((res) => {
          return res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getAllData() {
      let para = {
        djlcId: this.djlcId,
        tbdwmc: this.tbdwmc,
      };
      try {
        let res = await this.$api.isInit(para);
        if (res.status == 200) {
          this.isPublish = res.data.data.isPublish;
          res.data.data.dcbj.forEach((ele, index) => {
            this.dcbjHead = [...ele.cgkbdcbjList];
          });
          this.total = res.data.data.total;
          this.tableHead = res.data.data.bjxsmc;
          this.tableData = res.data.data.dcbj?.map(item => {
            item.cgkbdcbjqtcbList.forEach(sub => {
              item[sub.sxdm] = sub.srz
            })
            return item;
          });
        } else {
          this.$message({
            type: "error",
            message: res.data.meta.message,
          });
        }
      } catch (err) {
        console.log("招标人", err);
      }
    },
    getTableList() {
      this.loading = true;
      let para = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        tbdwmc: this.tbdwmc,
        djlcId: this.djlcId,
      };
      this.$api
        .getCbData(para)
        .then((res) => {
          if (res.data.meta.success) {
            var objs = res.data.data.tbdwMap;
            this.total = res.data.data.data.total;
            // if (this.aaa) {
            //   this.tableHead = {
            //     "总报价（元）": "tbbj",
            //   };
            // } else {
            this.tableHead = res.data.data.bjxsmc;
            // }
            if (objs) {
              var arr = res.data.data.data.tbdwList;
              arr.forEach((item, index) => {
                for (let key in objs[item.id]) {
                  item[key] = objs[item.id][key];
                }
              });
              this.tableData = arr;
            } else {
              this.tableData = res.data.data.data.tbdwList;
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        })
    },
    searchTbdw() {
      this.currentPage = 1;
      this.getData();
    },
    changePage(val) {
      this.currentPage = val;
      this.getData();
    },

    // 加载唱标表格数据
    async getData() {
      this.loading = true;
      let type = await this.getFileType();
      //项目大类1、采购项目 2、工程项目
      if (type == "1") {
        // 还得区分是否是多次报价的项目
        await this.getAllData();
        this.loading = false;
      }
      if (![1, 2, 3].includes(this.isPublish)) {
        this.getTableList();
      }
    },

    // 导出唱标信息
    async exportCbInfo() {
      try {
        const res = await this.$api.exportCbInfo();
        if (res) {
          const fileName = decodeURIComponent(res.headers['content-disposition'].split("=")[1]);
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click(); 
        }
      } catch (err) {
        console.log("导出唱标信息", err);
      }
    },
    refresh() {
      this.getData();
    },
  },
  async mounted() {
    await this.getCbData();
    if (this.sfchjy) {
      this.timer = setInterval(() => {
        this.getCbData();
      }, 15000);
    }
  },
};
</script>    
